import * as CA from './index.styled';
import { message, Select, Form, Input, Checkbox, Tag, Upload, Button, Modal, Table, DatePicker, TimePicker } from 'antd';
import { CampaignData, CampaignInputData, CampaignResponse, SubCampaignData } from '@/@types/CampaignData';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/ko';
import axiosRequest from '@/api';
import { ResData } from '@/@types';
import useFetchAdvertisers from '@/hooks/useFetchAdvertisers';
import { advertiserAtom } from '@/recoil/atoms/advertiger.atom';
import { useRecoilValue } from 'recoil';
import ImageUpload from '@/components/@common/ImageUpload';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { AxiosError } from 'axios';
import { MediaAuthMethod, SelectedMedia } from '@/@types/MediaAuthMethod';
import { CampaignProductData } from '@/@types/CampaignProduct';
import { AgencyData } from '@/@types/Agency';
import { ClientData } from '@/@types/Client';
import { useRecoilState } from 'recoil';
import { userAtom } from '@/recoil/atoms/user.atom';
import { InfoCircleOutlined, UploadOutlined, EditOutlined, HistoryOutlined } from '@ant-design/icons';
import SubCampaignComponent from '../SubCampaign';
import { CampaignChangeHistoryItem, CampaignChangeHistoryResponse } from '@/@types/CampaignHistory';
import { CheckboxChangeEvent } from 'antd/es/checkbox';


const { Option } = Select;
const { RangePicker } = DatePicker;
dayjs.locale('ko');

// 단가 이력 타입 정의
interface PricingHistoryItem {
    id: number;
    effective_from: string;
    points_per_call: number;
    points_per_participant: number;
    created_at: string;
    updated_at: string;
    created_by?: string;
    updated_by?: string;
    is_latest: boolean;
}

interface PricingChangeData {
    effective_from: string;
    points_per_call: number;
    points_per_participant: number;
}

function CampaignAdd() {
    const [user, setUser] = useRecoilState(userAtom);
    const [form] = Form.useForm();
    const [pricingForm] = Form.useForm();
    const [allFormData, setAllFormData] = useState<Partial<CampaignData>>({});
    const fetchAdvertisers = useFetchAdvertisers();
    const advertisers = useRecoilValue(advertiserAtom);

    const [campaignContent, setCampaignContent] = useState('');
    const [campaignDetails, setCampaignDetails] = useState('');
    const CampaignDefaultImage = '/assets/img/CampaignDefaultImage.svg';
    const SmallBannerDefalutImage = '/assets/img/Small_banner_img.svg';
    const [bannerImages, setBannerImages] = useState<string[]>([]);
    const [subBannerImages, setSubBannerImages] = useState<string[]>([]);
    const [totalImageExImages, setTotaImageExImages] = useState<string[]>([]);

    // 단가 관련 상태
    const [currentPricing, setCurrentPricing] = useState({
        points_per_call: 0,
        points_per_participant: 0
    });
    const [pricingHistoryVisible, setPricingHistoryVisible] = useState(false);
    const [pricingChangeVisible, setPricingChangeVisible] = useState(false);
    const [pricingHistory, setPricingHistory] = useState<PricingHistoryItem[]>([]);
    const [editingPricing, setEditingPricing] = useState<PricingHistoryItem | null>(null);

    const navigate = useNavigate();
    const { id } = useParams();
    const [startDate, setStartDate] = useState<Dayjs | null>(null);
    const [endDate, setEndDate] = useState<Dayjs | null>(null);
    const [mediaAuthMethods, setMediaAuthMethods] = useState<MediaAuthMethod[]>([]);
    const [campaignProducts, setCampaignProducts] = useState<CampaignProductData[]>([]);
    const [selectedMedia, setSelectedMedia] = useState<SelectedMedia | null>(null);
    const [agencySelected, setAgencySelected] = useState<boolean>(false);
    const [agencies, setAgencies] = useState<AgencyData[]>([]);
    const [clients, setClients] = useState<ClientData[]>([]);
    const [isEndDateRequired, setIsEndDateRequired] = useState(false);
    const [relatedContentActive, setRelatedContentActive] = useState(true);
    const [extractedTexts, setExtractedTexts] = useState<string[]>([]);
    const [isTotalImage, setIsTotalImage] = useState(false);

    // 변경 이력 관련 상태 추가
    const [changeHistoryVisible, setChangeHistoryVisible] = useState(false);
    const [changeHistory, setChangeHistory] = useState<CampaignChangeHistoryItem[]>([]);
    const [changeHistoryLoading, setChangeHistoryLoading] = useState(false);
    const [changeHistoryTotal, setChangeHistoryTotal] = useState(0);
    const [changeHistoryPage, setChangeHistoryPage] = useState(1);


    // 서브캠페인 관련 상태
    const [isAppType, setIsAppType] = useState(false);
    const [subCampaigns, setSubCampaigns] = useState<SubCampaignData[]>([]);
    const [eventNameRequired, setEventNameRequired] = useState(false);

    // 수정 시에만 사용할 테스트 기간 관련 상태
    const [isTestPeriodEnabled, setIsTestPeriodEnabled] = useState(false);
    const [testStartDate, setTestStartDate] = useState<Dayjs | null>(null);
    const [testEndDate, setTestEndDate] = useState<Dayjs | null>(null);

    // 일일 적립 수 제한 관련 상태 추가
    const [isDailyCapEnabled, setIsDailyCapEnabled] = useState(false);

    const [newData, setNewData] = useState<CampaignInputData>({
        title: '',
        start_date: '',
        end_date: '',
        related_url: '',
        related_content: '',
        total_points: '',
        campaign_content: '',
        campaign_details: '',
        banner_img: '',
        status: 'a',
        advertiser_id: null,
        agency_id: null,
        participation_count: 0,
        participation_count_p: 0,
        participation_count_d: 0,
        participation_count_r: 0,
        small_banner_img: '',
        campaign_product_id: null,
        total_img_ex_img: '',
        event_name: '',
        sub_campaigns: [],
        has_test_period: false,
        test_start_date: null,
        test_end_date: null,
        daily_cap: 0,
    });


    // 일일 적립 수 제한 토글 핸들러
    const handleDailyCapToggle = (e: any) => {
        const checked = e.target.checked;
        setIsDailyCapEnabled(checked);

        if (checked) {
            // 일일 적립 수 제한을 활성화할 때 기본값 설정
            const defaultDailyCap = 100; // 적절한 기본값
            setNewData(prevData => ({
                ...prevData,
                daily_cap: defaultDailyCap,
            }));
            form.setFieldsValue({
                daily_cap: defaultDailyCap,
            });
        } else {
            // 일일 적립 수 제한을 비활성화할 때 0으로 설정
            setNewData(prevData => ({
                ...prevData,
                daily_cap: 0,
            }));
            form.setFieldsValue({
                daily_cap: 0,
            });
        }
    };

    // 1. 숫자 포맷팅 함수 추가 (컴포넌트 상단에 추가)
    const formatNumberWithComma = (value: string): string => {
        const numericValue = value.replace(/[^0-9]/g, '');
        if (numericValue === '') return '';
        if (numericValue === '0') return '0';
        return parseInt(numericValue).toLocaleString();
    };
    const getNumericValue = (value: string): string => {
        return value.replace(/[^0-9]/g, '');
    };


    const handleTestPeriodToggle = (e: CheckboxChangeEvent) => {
        const checked = e.target.checked;
        setIsTestPeriodEnabled(checked);

        if (checked) {
            // 캠페인 시작일이 없으면 테스트 기간을 활성화할 수 없음
            if (!startDate) {
                message.error('캠페인 시작일을 먼저 설정해주세요.');
                setIsTestPeriodEnabled(false);
                return;
            }

            // 기본값은 설정하지 않고 사용자가 직접 선택하도록 함
            setNewData(prevData => ({
                ...prevData,
                has_test_period: true,
            }));
        } else {
            // 테스트 기간을 비활성화할 때 값 초기화
            setTestStartDate(null);
            setTestEndDate(null);
            setNewData(prevData => ({
                ...prevData,
                has_test_period: false,
                test_start_date: null,
                test_end_date: null,
            }));
            form.setFieldsValue({
                test_start_date: null,
                test_end_date: null,
            });
        }
    };
    // 테스트 날짜 변경 핸들러들
    const handleTestStartDateChange = (date: Dayjs | null) => {
        setTestStartDate(date);
        setNewData(prevData => ({
            ...prevData,
            test_start_date: date ? date.format('YYYY-MM-DD') : null,
        }));

        // 테스트 시작일이 변경되면 종료일도 자동으로 조정
        if (date && (!testEndDate || testEndDate.isBefore(date))) {
            const newEndDate = date.add(1, 'day');

            // 캠페인 시작일을 넘지 않도록 체크
            const finalEndDate = startDate && newEndDate.isAfter(startDate.subtract(1, 'day'))
                ? startDate.subtract(1, 'day')
                : newEndDate;

            setTestEndDate(finalEndDate);
            setNewData(prevData => ({
                ...prevData,
                test_end_date: finalEndDate.format('YYYY-MM-DD'),
            }));
            form.setFieldsValue({
                test_end_date: finalEndDate,
            });
        }
    };

    const handleTestEndDateChange = (date: Dayjs | null) => {
        // 선택된 날짜가 테스트 시작일 이전인지 체크
        if (date && testStartDate && date.isBefore(testStartDate.startOf('day'))) {
            message.error('테스트 종료일은 테스트 시작일 이후로 설정해주세요.');
            return;
        }

        // 선택된 날짜가 캠페인 시작일 이후인지 체크
        if (date && startDate && date.isAfter(startDate.subtract(1, 'day'))) {
            message.error('테스트 종료일은 캠페인 시작일 이전으로 설정해주세요.');
            return;
        }

        setTestEndDate(date);
        setNewData(prevData => ({
            ...prevData,
            test_end_date: date ? date.format('YYYY-MM-DD') : null,
        }));
    };

    // 테스트 날짜 제한 함수들 수정
    const disabledTestStartDate = (current: Dayjs | null): boolean => {
        if (!current) return false;

        // 캠페인 시작일 이후 선택 불가 (시작일 당일도 불가)
        if (startDate && current.isAfter(startDate.subtract(1, 'day'))) {
            return true;
        }

        return false;
    };



    const disabledTestEndDate = (current: Dayjs | null): boolean => {
        if (!current) return false;

        // 테스트 시작일 이전 선택 불가
        if (testStartDate && current.isBefore(testStartDate.startOf('day'))) {
            return true;
        }

        // 캠페인 시작일 이후 선택 불가 (시작일 당일도 불가)
        if (startDate && current.isAfter(startDate.subtract(1, 'day'))) {
            return true;
        }

        return false;
    };

    // 단가 이력 조회
    const fetchPricingHistory = async (campaignId: number) => {
        try {
            const response = await axiosRequest.requestAxios<ResData<{ history: PricingHistoryItem[], total_count: number }>>(
                'get',
                `/campaigns/${campaignId}/pricing-history`
            );
            setPricingHistory(response.data.history);
        } catch (error) {
            console.error('단가 이력 조회 실패:', error);
        }
    };

    // 단가 변경/추가
    const handlePricingSubmit = async (values: any) => {
        if (!id) {
            message.error('캠페인이 먼저 저장되어야 합니다.');
            return;
        }

        try {
            const pricingData: PricingChangeData = {
                effective_from: values.effective_datetime.format('YYYY-MM-DD HH:mm:ss'),
                // 컴마 제거하고 숫자만 전송
                points_per_call: parseInt(getNumericValue(values.points_per_call || '')),
                points_per_participant: parseInt(getNumericValue(values.points_per_participant || ''))
            };

            if (editingPricing) {
                // 기존 이력 수정
                await axiosRequest.requestAxios(
                    'put',
                    `/campaigns/${id}/pricing-history/${editingPricing.id}`,
                    pricingData
                );
                message.success('단가 이력이 수정되었습니다.');
            } else {
                // 새 이력 추가
                await axiosRequest.requestAxios(
                    'post',
                    `/campaigns/${id}/pricing-history`,
                    pricingData
                );
                message.success('단가 이력이 추가되었습니다.');
            }

            // 모달 닫기 및 이력 새로고침
            setPricingChangeVisible(false);
            setEditingPricing(null);
            pricingForm.resetFields();
            fetchPricingHistory(parseInt(id));

            // 현재 단가 업데이트
            setCurrentPricing({
                points_per_call: pricingData.points_per_call,
                points_per_participant: pricingData.points_per_participant
            });

        } catch (error) {
            console.error('단가 변경 실패:', error);
            message.error('단가 변경에 실패했습니다.');
        }
    };


    // 단가 이력 테이블 컬럼
    const pricingHistoryColumns = [
        {
            title: '적용 일시',
            dataIndex: 'effective_from',
            key: 'effective_from',
            render: (text: string) => dayjs(text).format('YYYY-MM-DD HH:mm'),
        },
        {
            title: '광고 단가',
            dataIndex: 'points_per_call',
            key: 'points_per_call',
            render: (value: number) => `${value.toLocaleString()}원`,
        },
        {
            title: '고객 리워드',
            dataIndex: 'points_per_participant',
            key: 'points_per_participant',
            render: (value: number) => `${value.toLocaleString()}원`,
        },
        {
            title: '작업',
            key: 'action',
            render: (_: any, record: PricingHistoryItem) => {
                const isFuture = dayjs(record.effective_from).isAfter(dayjs());
                return (
                    <Button
                        type="link"
                        icon={<EditOutlined />}
                        disabled={!isFuture}
                        onClick={() => {
                            setEditingPricing(record);
                            pricingForm.setFieldsValue({
                                effective_datetime: dayjs(record.effective_from),
                                points_per_call: record.points_per_call,
                                points_per_participant: record.points_per_participant,
                            });
                            setPricingChangeVisible(true);
                        }}
                    >
                        {isFuture ? '수정' : '수정불가'}
                    </Button>
                );
            },
        },
    ];

    // 변경 이력 조회 함수
    const fetchChangeHistory = async (campaignId: number, page: number = 1) => {
        setChangeHistoryLoading(true);
        try {
            const response = await axiosRequest.requestAxios<ResData<CampaignChangeHistoryResponse>>(
                'get',
                `/campaigns/${campaignId}/change-history?page=${page}&size=10`
            );
            setChangeHistory(response.data.history);
            setChangeHistoryTotal(response.data.total_count);
        } catch (error) {
            console.error('변경 이력 조회 실패:', error);
            message.error('변경 이력을 불러오는데 실패했습니다.');
        } finally {
            setChangeHistoryLoading(false);
        }
    };
    // 필드명 한국어 매핑
    const getFieldDisplayName = (field: string): string => {
        const fieldMap: Record<string, string> = {
            'title': '캠페인 제목',
            'advertiser_id': '광고주',
            'agency_id': '대행사',
            'campaign_product_id': '상품',
            'start_date': '시작 날짜',
            'end_date': '종료 날짜',
            'status': '상태',
            'related_content': '관련 콘텐츠',
            'related_url': '참여 URL',
            'total_points': '총 집행 광고비',
            'campaign_content': '광고 문구',
            'campaign_details': '상세 설명',
            'banner_img': '배너 이미지',
            'small_banner_img': '리스트 배너',
            'total_img_ex_img': '통합 이미지 분석 예시',
            'event_name': '이벤트 이름',
            'has_sub': '서브 캠페인 여부',
            // 새로 추가된 필드들
            'points_per_call': '광고 단가',
            'points_per_participant': '고객 리워드',
            'has_test_period': '테스트 기간 설정',
            'test_start_date': '테스트 시작일',
            'test_end_date': '테스트 종료일',
            'daily_cap': '일일 적립 수 제한',
            'media': '미디어',
            'authentication_method': '인증 방식',
            'sub_campaigns': '서브 캠페인',
            'created_at': '생성일',
            'updated_at': '수정일',
            'created_by': '생성자',
            'updated_by': '수정자',
            'participation_count': '참여 수',
            'participation_count_p': '미적립 참여 수',
            'participation_count_d': '반려 참여 수',
            'participation_count_r': '적립 완료 수',
            'initial_point': '초기 광고비',
            'used_point': '사용된 광고비',
            'remaining_point': '잔여 광고비',
        };
        return fieldMap[field] || field;
    };
    // 값 표시 포맷팅
    const formatFieldValue = (field: string, value: any): string => {
        if (value === null || value === undefined) {
            return '(없음)';
        }

        // 상태 값 변환
        if (field === 'status') {
            const statusMap: Record<string, string> = {
                'a': '승인',
                'p': '대기',
                'd': '반려'
            };
            return statusMap[value] || value;
        }

        // boolean 값 변환 (has_test_period, has_sub 등)
        if (typeof value === 'boolean' || field === 'has_test_period' || field === 'has_sub') {
            const boolValue = typeof value === 'boolean' ? value : (value === true || value === 'true' || value === 1 || value === '1');
            return boolValue ? '예' : '아니오';
        }

        // 날짜 포맷팅
        if ((field.includes('date') || field.includes('_at')) && value) {
            return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
        }

        // 숫자 포맷팅 (금액 관련 필드들)
        if (field.includes('points') || field === 'total_points' || field === 'daily_cap') {
            const numValue = parseInt(value);
            if (!isNaN(numValue)) {
                if (field === 'daily_cap') {
                    return numValue === 0 ? '제한 없음' : `${numValue.toLocaleString()}회`;
                }
                return `${numValue.toLocaleString()}원`;
            }
        }

        // 참여 수 관련 필드들
        if (field.includes('participation_count')) {
            const numValue = parseInt(value);
            if (!isNaN(numValue)) {
                return `${numValue.toLocaleString()}건`;
            }
        }

        // 미디어 타입 변환
        if (field === 'media') {
            const mediaMap: Record<string, string> = {
                'image': '이미지',
                'video': '비디오',
                'action': '액션완료',
                'total_image': '통합 이미지',
                'survey': '설문조사'
            };
            return mediaMap[value] || value;
        }

        // 인증 방식 변환
        if (field === 'authentication_method') {
            const authMap: Record<string, string> = {
                'image_upload': '이미지 업로드',
                'text_input': '텍스트 입력',
                'url_visit': 'URL 방문',
                'app_install': '앱 설치'
            };
            return authMap[value] || value;
        }

        // 서브 캠페인 배열 처리
        if (field === 'sub_campaigns' && Array.isArray(value)) {
            return value.length > 0 ? `${value.length}개의 서브 캠페인` : '서브 캠페인 없음';
        }

        // 긴 텍스트 줄임
        if (typeof value === 'string' && value.length > 50) {
            return value.substring(0, 50) + '...';
        }

        return String(value);
    };

    // 변경 유형 표시
    const getChangeTypeBadge = (type: string) => {
        const typeConfig = {
            'CREATE': { color: 'green', text: '생성' },
            'UPDATE': { color: 'blue', text: '수정' },
            'DELETE': { color: 'red', text: '삭제' }
        };

        const config = typeConfig[type as keyof typeof typeConfig] || { color: 'default', text: type };

        return (
            <Tag color={config.color}>
                {config.text}
            </Tag>
        );
    };

    // 상세 변경 내용 모달
    const showChangeDetails = (record: CampaignChangeHistoryItem) => {
        const changedFields = Object.entries(record.changed_fields);

        Modal.info({
            title: (
                <div>
                    <InfoCircleOutlined style={{ marginRight: 8 }} />
                    변경 상세 내용
                </div>
            ),
            content: (
                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {changedFields.length === 0 ? (
                        <div style={{ textAlign: 'center', color: '#999', padding: '20px' }}>
                            변경된 항목이 없습니다.
                        </div>
                    ) : (
                        <div>
                            {changedFields.map(([field, change]) => (
                                <div key={field} style={{
                                    marginBottom: '16px',
                                    padding: '12px',
                                    backgroundColor: '#fafafa',
                                    borderRadius: '6px',
                                    border: '1px solid #f0f0f0'
                                }}>
                                    <div style={{
                                        fontWeight: 'bold',
                                        marginBottom: '8px',
                                        color: '#1890ff'
                                    }}>
                                        {getFieldDisplayName(field)}
                                    </div>
                                    <div style={{ display: 'flex', gap: '16px' }}>
                                        <div style={{ flex: 1 }}>
                                            <div style={{
                                                fontSize: '12px',
                                                color: '#666',
                                                marginBottom: '4px'
                                            }}>
                                                이전 값
                                            </div>
                                            <div style={{
                                                padding: '8px',
                                                backgroundColor: '#fff2f0',
                                                borderRadius: '4px',
                                                border: '1px solid #ffccc7'
                                            }}>
                                                {formatFieldValue(field, change.before)}
                                            </div>
                                        </div>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            color: '#1890ff'
                                        }}>
                                            →
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <div style={{
                                                fontSize: '12px',
                                                color: '#666',
                                                marginBottom: '4px'
                                            }}>
                                                변경 값
                                            </div>
                                            <div style={{
                                                padding: '8px',
                                                backgroundColor: '#f6ffed',
                                                borderRadius: '4px',
                                                border: '1px solid #b7eb8f'
                                            }}>
                                                {formatFieldValue(field, change.after)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            ),
            width: 700,
            okText: '확인'
        });
    };

    // 변경 이력 테이블 컬럼
    const changeHistoryColumns = [
        {
            title: '변경 일시',
            dataIndex: 'changed_at',
            key: 'changed_at',
            width: 150,
            render: (text: string) => (
                <div>
                    <div>{dayjs(text).format('YYYY-MM-DD')}</div>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                        {dayjs(text).format('HH:mm:ss')}
                    </div>
                </div>
            ),
        },
        {
            title: '변경 유형',
            dataIndex: 'change_type',
            key: 'change_type',
            width: 80,
            render: (type: string) => getChangeTypeBadge(type)
        },
        {
            title: '변경 내용',
            dataIndex: 'change_summary',
            key: 'change_summary',
            ellipsis: true,
        },
        {
            title: '변경자',
            dataIndex: 'changed_by',
            key: 'changed_by',
            width: 120,
            ellipsis: true,
        },
        {
            title: '상세',
            key: 'details',
            width: 80,
            render: (_: any, record: CampaignChangeHistoryItem) => (
                <Button
                    type="link"
                    size="small"
                    icon={<InfoCircleOutlined />}
                    onClick={() => showChangeDetails(record)}
                >
                    상세보기
                </Button>
            ),
        },
    ];


    useEffect(() => {
        const fetchMediaAuthMethods = async () => {
            try {
                const response = await axiosRequest.requestAxios<ResData<MediaAuthMethod[]>>('get', '/media_auth_methods');
                setMediaAuthMethods(response.data);
            } catch (error) {
                console.error('Media auth methods fetching error:', error);
            }
        };

        fetchMediaAuthMethods();

        const fetchCampaignProducts = async () => {
            try {
                const response = await axiosRequest.requestAxios<ResData<CampaignProductData[]>>('get', '/campaign_products_select');
                setCampaignProducts(response.data);
            } catch (error) {
                console.error('Media auth methods fetching error:', error);
            }
        }
        fetchCampaignProducts();

        const fetchAgencies = async () => {
            try {
                const response = await axiosRequest.requestAxios<ResData<AgencyData[]>>('get', '/agencies');
                setAgencies(response.data);
            } catch (error) {
                console.error("fetchAgencies error: ", error)
            }
        }
        fetchAgencies();

        if (user?.role_name === "advertiser") {
            const fetchClients = async (agency_id: number) => {
                try {
                    const response = await axiosRequest.requestAxios<ResData<AgencyData[]>>('get', `/clients/${agency_id}`);
                    setClients(response.data);
                } catch (error) {
                    console.error("fetchClients error: ", error)
                }
            }

            setAgencySelected(true);
            fetchClients(user?.advertiser_id ? user?.advertiser_id : 0);
        }
    }, []);

    const fetchClients = async (agency_id: number) => {
        try {
            const response = await axiosRequest.requestAxios<ResData<AgencyData[]>>('get', `/clients/${agency_id}`);
            setClients(response.data);
        } catch (error) {
            console.error("fetchClients error: ", error)
        }
    }

    const location = useLocation();
    const campaignListPath = `/admin/campaign`;
    const campaignAddPath = `/admin/campaign/add`;
    const campaignEditPath = `/admin/campaign/add/${id}`;

    useEffect(() => {
        fetchAdvertisers();
    }, []);

    // useEffect 내의 fetchCampaignData 함수에서 수정해야 할 부분

    useEffect(() => {
        const fetchCampaignData = async () => {
            if (id) {
                try {
                    const response = await axiosRequest.requestAxios<ResData<CampaignData>>('get', `/campaign/${id}`);
                    if (response.data) {
                        const campaign = response.data;

                        // 현재 적용중인 단가 설정
                        setCurrentPricing({
                            points_per_call: campaign.points_per_call || 0,
                            points_per_participant: campaign.points_per_participant || 0
                        });

                        // 단가 이력 조회
                        await fetchPricingHistory(parseInt(id));

                        // 기존 로직들...
                        const advertiserId = campaign.advertiser_id ? campaign.advertiser_id.toString() : '';
                        const agencyId = campaign.agency_id ? campaign.agency_id.toString() : '';
                        const campaignProductId = campaign.campaign_product_id ? campaign.campaign_product_id.toString() : '';
                        const bannerImages = campaign.banner_img ? campaign.banner_img.split(',') : [];
                        const subBannerImages = campaign.small_banner_img ? campaign.small_banner_img.split(',') : [];
                        const totalImageExImages = campaign.total_img_ex_img ? campaign.total_img_ex_img.split(',') : [];

                        // 날짜 설정
                        const startDate = campaign.start_date ? dayjs(campaign.start_date) : null;
                        const endDate = campaign.end_date ? dayjs(campaign.end_date) : null;
                        setStartDate(startDate);
                        setEndDate(endDate);
                        setIsEndDateRequired(campaign.end_date ? true : false);

                        // ✅ 상품 정보를 기반으로 관련 콘텐츠 활성화 여부 설정
                        const selectedProduct = campaignProducts.find(cp => cp.id === campaign.campaign_product_id);
                        if (selectedProduct) {
                            if (selectedProduct.media === 'action') {
                                setRelatedContentActive
                                setRelatedContentActive(false);
                            } else {
                                setRelatedContentActive(true);
                            }

                            if (selectedProduct.media === 'total_image') {
                                setIsTotalImage(true);
                            } else {
                                setIsTotalImage(false);
                            }

                            if (selectedProduct.sub_media === 'app') {
                                setIsAppType(true);
                                setEventNameRequired(true);
                            } else {
                                setIsAppType(false);
                                setEventNameRequired(false);
                            }
                        } else {
                            // ✅ 상품 정보가 없는 경우 campaign.media로 fallback (기존 로직 유지)
                            if (campaign.media === 'action') {
                                setRelatedContentActive(false);
                            } else {
                                setRelatedContentActive(true);
                            }

                            if (campaign.media === 'total_image') {
                                setIsTotalImage(true);
                            } else {
                                setIsTotalImage(false);
                            }
                        }

                        // 테스트 기간 관련 설정
                        if (campaign.has_test_period) {
                            setIsTestPeriodEnabled(true);
                            setTestStartDate(campaign.test_start_date ? dayjs(campaign.test_start_date) : null);
                            setTestEndDate(campaign.test_end_date ? dayjs(campaign.test_end_date) : null);
                        }

                        // 일일 적립 수 제한 설정
                        if (campaign.daily_cap && campaign.daily_cap > 0) {
                            setIsDailyCapEnabled(true);
                        }

                        // 기존 미디어 관련 로직
                        const selectedMedia = mediaAuthMethods.find(media => media.name === campaign.media);
                        const selectedAuthMethod = selectedMedia?.auth.find(
                            auth => auth[0] === campaign.authentication_method,
                        )?.[1];

                        if (selectedMedia && selectedAuthMethod) {
                            setSelectedMedia(selectedMedia);
                            form.setFieldsValue({
                                media: selectedMedia.k_name,
                                authentication_method: selectedAuthMethod,
                            });
                        }

                        if (agencyId) {
                            fetchClients(Number(agencyId));
                            setAgencySelected(true);
                        }

                        // 폼 데이터 설정 시 가격 필드에 컴마 포맷팅 적용
                        form.setFieldsValue({
                            ...campaign,
                            advertiser_id: advertiserId,
                            agency_id: agencyId,
                            campaign_product_id: campaignProductId,
                            banner_img: bannerImages,
                            start_date: startDate,
                            end_date: endDate,
                            small_banner_img: subBannerImages,
                            total_img_ex_img: totalImageExImages,
                            sub_campaigns: campaign.sub_campaigns || [],
                            event_name: campaign.event_name || '',
                            has_test_period: campaign.has_test_period || false,
                            test_start_date: campaign.test_start_date ? dayjs(campaign.test_start_date) : null,
                            test_end_date: campaign.test_end_date ? dayjs(campaign.test_end_date) : null,
                            daily_cap: campaign.daily_cap || 0,
                            // 가격 필드들에 컴마 포맷팅 적용 (천단위 컴마)
                            total_points: campaign.total_points ? parseInt(campaign.total_points.toString()).toLocaleString() : '',
                            points_per_call: campaign.points_per_call ? parseInt(campaign.points_per_call.toString()).toLocaleString() : '',
                            points_per_participant: campaign.points_per_participant ? parseInt(campaign.points_per_participant.toString()).toLocaleString() : '',
                        });

                        // setNewData는 원본 숫자 값으로 설정 (서버 전송용)
                        setNewData({
                            ...response.data,
                            sub_campaigns: campaign.sub_campaigns || [],
                            has_test_period: campaign.has_test_period || false,
                            test_start_date: campaign.test_start_date || '',
                            test_end_date: campaign.test_end_date || '',
                            daily_cap: campaign.daily_cap || 0,
                        });

                        // 기존 로직들...
                        setCampaignDetails(response.data.campaign_details);
                        setCampaignContent(response.data.campaign_content);
                        setBannerImages(bannerImages);
                        setSubBannerImages(subBannerImages);
                        setTotaImageExImages(totalImageExImages);
                    }
                } catch (error) {
                    console.error('캠페인 데이터 로드 실패', error);
                }
            }
        };

        fetchCampaignData();
    }, [id, form, mediaAuthMethods, campaignProducts]); // ✅ campaignProducts 의존성 추가

    const formatCampaignDataForSubmit = (formData: any) => {
        const processedData = { ...formData };

        // 1. 날짜 형식 변환 (ISO -> YYYY-MM-DD)
        const formatDate = (dateValue: any) => {
            if (!dateValue) return null;

            if (typeof dateValue === 'object' && dateValue.format) {
                // Dayjs 객체인 경우
                return dateValue.format('YYYY-MM-DD');
            } else if (typeof dateValue === 'string') {
                // ISO 문자열인 경우 (예: "2025-07-02T15:00:00.000Z")
                if (dateValue.includes('T')) {
                    return dateValue.split('T')[0];
                }
                return dateValue; // 이미 YYYY-MM-DD 형식인 경우
            }
            return dateValue;
        };

        processedData.start_date = formatDate(processedData.start_date);
        processedData.end_date = formatDate(processedData.end_date);
        processedData.test_start_date = formatDate(processedData.test_start_date);
        processedData.test_end_date = formatDate(processedData.test_end_date);

        if (processedData.has_test_period === undefined || processedData.has_test_period === null) {
            processedData.has_test_period = isTestPeriodEnabled; // 체크박스 상태에서 가져오기
        }

        // 테스트 기간이 비활성화된 경우 날짜를 null로 설정
        if (processedData.has_test_period === false) {
            processedData.test_start_date = null;
            processedData.test_end_date = null;
        }

        // 2. 숫자 필드에서 쉼표 제거 및 정수 변환
        const formatNumber = (numberValue: any) => {
            if (numberValue === null || numberValue === undefined || numberValue === '') {
                return 0;
            }
            if (typeof numberValue === 'string') {
                return parseInt(numberValue.replace(/,/g, ''), 10) || 0;
            }
            return numberValue;
        };

        processedData.total_points = formatNumber(processedData.total_points);
        processedData.daily_cap = formatNumber(processedData.daily_cap);

        // 3. 단가 필드 처리 - currentPricing에서 값 가져오기
        if (!processedData.points_per_call && currentPricing?.points_per_call) {
            processedData.points_per_call = currentPricing.points_per_call;
        } else {
            processedData.points_per_call = formatNumber(processedData.points_per_call);
        }

        if (!processedData.points_per_participant && currentPricing?.points_per_participant) {
            processedData.points_per_participant = currentPricing.points_per_participant;
        } else {
            processedData.points_per_participant = formatNumber(processedData.points_per_participant);
        }

        // 4. 문자열 필드 처리 (null/undefined를 빈 문자열로)
        processedData.related_content = processedData.related_content || "";
        processedData.total_img_ex_img = processedData.total_img_ex_img || "";
        processedData.event_name = processedData.event_name || "";

        // 5. 서브 캠페인이 없으면 빈 배열로 설정
        processedData.sub_campaigns = processedData.sub_campaigns || [];

        // 6. ID 필드 처리 (문자열을 숫자로 변환)
        if (processedData.advertiser_id && typeof processedData.advertiser_id === 'string') {
            processedData.advertiser_id = parseInt(processedData.advertiser_id, 10);
        }
        if (processedData.agency_id && typeof processedData.agency_id === 'string') {
            processedData.agency_id = parseInt(processedData.agency_id, 10);
        }
        if (processedData.campaign_product_id && typeof processedData.campaign_product_id === 'string') {
            processedData.campaign_product_id = parseInt(processedData.campaign_product_id, 10);
        }

        return processedData;
    };

    const handleSubmit = async () => {
        try {
            if (eventNameRequired && !form.getFieldValue('event_name')) {
                message.error('이벤트 이름을 입력해주세요.');
                return;
            }

            if (newData.agency_id == null) {
                newData.agency_id = user?.advertiser_id ? user?.advertiser_id : 0
            }

            const formSubCampaigns = form.getFieldValue('sub_campaigns') || [];

            // 기본 폼 데이터 구성
            const formData = {
                ...newData,
                banner_img: bannerImages.join(','),
                small_banner_img: subBannerImages.join(','),
                total_img_ex_img: totalImageExImages.join(','),
                event_name: form.getFieldValue('event_name'),
                sub_campaigns: formSubCampaigns
            };

            // 생성 시에는 테스트 기간 관련 필드 제거 (백엔드에서 자동 설정)
            // ✅ URL 파라미터 id 사용으로 수정
            if (!id) {
                delete formData.has_test_period;
                delete formData.test_start_date;
                delete formData.test_end_date;
                // daily_cap은 유지 (사용자가 입력한 값)
            }

            // **데이터 형식 변환 처리 추가**
            const processedData = formatCampaignDataForSubmit(formData);

            console.log('전송할 데이터:', processedData); // 디버깅용
            console.log('수정 모드:', !!id); // 디버깅용

            // ✅ URL 파라미터 id 사용으로 수정
            const response = await axiosRequest.requestAxios<ResData<CampaignResponse>>(
                id ? 'put' : 'post',
                id ? `/campaign/${id}` : '/campaign',
                processedData, // formData 대신 processedData 사용
            );

            if (response) {
                // ✅ URL 파라미터 id 사용으로 수정
                if (id) {
                    message.success('캠페인이 성공적으로 수정되었습니다.');
                    navigate('/admin/campaign');
                } else {
                    message.success('캠페인이 성공적으로 추가되었습니다.');
                    navigate('/admin/campaign');
                }
            }
        } catch (error) {
            const axiosError = error as AxiosError;
            if (axiosError.response && axiosError.response.data) {
                const detailMessage = (axiosError.response.data as any).detail;
                if (detailMessage === 'Advertiser status is not active') {
                    alert('광고주의 승인 상태를 확인해주세요');
                } else {
                    message.error('캠페인 등록에 실패했습니다.');
                    console.error('상세 에러:', detailMessage); // 에러 상세 로그 추가
                }
            }
        }
    };


    const handleFormValuesChange = (changedValues: any, allValues: CampaignData) => {
        setNewData(allValues);
    };

    const handleSelectChange = (name: string) => (value: string | number) => {
        setNewData(prevData => ({
            ...prevData,
            [name]: value.toString(),
        }));

        if (name == 'agency_id') {
            setAgencySelected(true);
            form.setFieldsValue({
                clients: [],
                advertiser_id: null
            });
            fetchClients(Number(value));
        }

        if (name === 'campaign_product_id') {
            const selectedProduct = campaignProducts.find(cp => cp.id === Number(value));
            if (selectedProduct) {
                // 생성 시에만 단가 필드 설정
                if (!id) {
                    form.setFieldsValue({
                        points_per_call: selectedProduct.promotion_point ? selectedProduct.promotion_point : selectedProduct.basic_point,
                        points_per_participant: selectedProduct.promotion_reward_point ? selectedProduct.promotion_reward_point : selectedProduct.reward_point,
                    });

                    setNewData(prevData => ({
                        ...prevData,
                        points_per_call: selectedProduct.basic_point?.toString() || '',
                        points_per_participant: selectedProduct.reward_point?.toString() || '',
                    }));
                }

                if (selectedProduct.media === 'action') {
                    setRelatedContentActive(false);
                } else {
                    setRelatedContentActive(true);
                }

                if (selectedProduct.media === 'total_image') {
                    setIsTotalImage(true);
                } else {
                    setIsTotalImage(false);
                    setExtractedTexts([]);
                    setNewData(prevData => ({
                        ...prevData,
                        related_content: '',
                    }))
                    form.setFieldsValue({
                        related_content: '',
                    });
                }

                if (selectedProduct.sub_media === 'app') {
                    setIsAppType(true);
                    setEventNameRequired(true);
                } else {
                    setIsAppType(false);
                    setEventNameRequired(false);
                }
            }
        }
    };

    // 기존 핸들러들... (날짜, 입력 등)
    const handleStartDateChange = (date: Dayjs | null) => {
        setStartDate(date);
        setNewData(prevData => ({
            ...prevData,
            start_date: date ? date.format('YYYY-MM-DD') : '',
        }));

        // 추가: 캠페인 시작일이 변경되면 테스트 시작일도 체크
        if (testStartDate && date && testStartDate.isBefore(date)) {
            // 테스트 시작일이 새로운 캠페인 시작일보다 이전이면 리셋
            setTestStartDate(null);
            setTestEndDate(null);
            form.setFieldsValue({
                test_start_date: null,
                test_end_date: null,
            });
            setNewData(prev => ({
                ...prev,
                test_start_date: null,
                test_end_date: null,
            }));
            message.warning('캠페인 시작일이 변경되어 테스트 기간이 초기화되었습니다.');
        }
    };


    const handleEndDateChange = (date: Dayjs | null) => {
        setEndDate(date);
        setNewData(prevData => ({
            ...prevData,
            end_date: date ? date.format('YYYY-MM-DD') : '',
        }));

        // 추가: 캠페인 종료일이 변경되면 테스트 종료일도 체크
        if (testEndDate && date && testEndDate.isAfter(date)) {
            // 테스트 종료일이 새로운 캠페인 종료일보다 이후면 리셋
            setTestEndDate(null);
            form.setFieldsValue({
                test_end_date: null,
            });
            setNewData(prev => ({
                ...prev,
                test_end_date: null,
            }));
            message.warning('캠페인 종료일이 변경되어 테스트 종료일이 초기화되었습니다.');
        }
    };

    const disabledStartDate = (current: Dayjs) => {
        return current.isBefore(dayjs().startOf('day'));
    };

    const disabledEndDate = (current: Dayjs) => {
        return startDate ? current.isBefore(startDate, 'day') : false;
    };

    // 2. 기존 handleInputChange 함수 수정
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;

        // 가격 관련 필드들
        const priceFields = ['total_points', 'points_per_call', 'points_per_participant'];

        if (priceFields.includes(name)) {
            // 숫자만 추출
            const numericValue = getNumericValue(value);

            // 컴마 추가한 값으로 폼 필드 업데이트
            const formattedValue = formatNumberWithComma(value);
            form.setFieldsValue({ [name]: formattedValue });

            // 실제 저장값은 숫자만
            setNewData(prev => ({ ...prev, [name]: numericValue }));
        } else {
            // 일반 필드 처리
            setNewData(prev => ({ ...prev, [name]: value }));
        }
    };

    // 3. 단가 변경 모달용 핸들러 추가
    const handlePricingInputChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        const numericValue = getNumericValue(value);
        const formattedValue = formatNumberWithComma(value);

        // 단가 폼에 컬마가 포함된 값 설정
        pricingForm.setFieldsValue({ [field]: formattedValue });
    };

    const handleSubCampaignsChange = (newSubCampaigns: SubCampaignData[]) => {
        setSubCampaigns(newSubCampaigns);
        setNewData(prevData => ({
            ...prevData,
            sub_campaigns: newSubCampaigns
        }));
    };

    const handleImageUpload = (imageUrls: string[]) => {
        setNewData(prevData => ({
            ...prevData,
            banner_img: imageUrls.join(','),
        }));

        form.setFieldsValue({
            banner_img: imageUrls.join(','),
        });

        setBannerImages(imageUrls);
    };

    const handleSubImageUpload = (imageUrls: string[]) => {
        setNewData(prevData => ({
            ...prevData,
            small_banner_img: imageUrls.join(','),
        }));

        form.setFieldsValue({
            small_banner_img: imageUrls.join(','),
        });

        setSubBannerImages(imageUrls);
    };

    const handleTotalExImageUpload = (imageUrls: string[]) => {
        setNewData(prevData => ({
            ...prevData,
            total_img_ex_img: imageUrls.join(',')
        }))
        form.setFieldsValue({
            total_img_ex_img: imageUrls.join(','),
        });

        setTotaImageExImages(imageUrls);
    }

    const handleFinishFailed = (errorInfo: any) => {
        message.error('필수 항목을 확인해주세요');
        console.error('Failed:', errorInfo);

        if (errorInfo.errorFields.length > 0) {
            const fieldName = errorInfo.errorFields[0].name[0];
            const fieldElement = document.getElementById(fieldName) ||
                document.getElementsByName(fieldName)[0];
            if (fieldElement) {
                fieldElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    };

    const handleImageUploadForTextExtraction = async (imageUrls: string[]) => {
        try {
            const response = await axiosRequest.requestAxios<ResData<string[]>>('post', '/extract_text_from_img', {
                images: imageUrls
            });
            setExtractedTexts(response.data);
            setNewData(prevData => ({
                ...prevData,
                related_content: response.data.join(', '),
            }));
            form.setFieldsValue({
                related_content: response.data.join(', '),
            });
        } catch (error) {
            console.error('Error extracting text from images:', error);
        }
    };

    const handleRemoveText = (index: number) => {
        setExtractedTexts(prevTexts => {
            const updatedTexts = prevTexts.filter((_, i) => i !== index);
            setNewData(prevData => ({
                ...prevData,
                related_content: updatedTexts.join(', '),
            }));
            form.setFieldsValue({
                related_content: updatedTexts.join(', '),
            });
            return updatedTexts;
        });
    };

    const handleAnalysisImageUpload = async (file: File) => {
        const formData = new FormData();
        formData.append('image', file, file.name);
        const response = await axiosRequest.requestAxios<ResData<string[]>>('post', '/extract_text_from_img', formData);
        console.log(response.data);
        setExtractedTexts(response.data);
        setNewData(prevData => ({
            ...prevData,
            related_content: response.data.join(', '),
        }));
        form.setFieldsValue({
            related_content: response.data.join(', '),
        });
    }

    const beforeUpload = (file: File) => {
        handleAnalysisImageUpload(file);
        return false;
    };

    useEffect(() => {
        if (user?.role_name === 'advertiser') {
            form.setFieldsValue({ agency_id: user?.advertiser_id?.toString() });
        }
    }, [user, form]);

    const handleCheckboxChange = (e: any) => {
        if (!e.target.checked) {
            setEndDate(null);
            setNewData(prevData => ({
                ...prevData,
                end_date: '',
            }));
            form.setFieldValue('end_date', '');
        }
        setIsEndDateRequired(e.target.checked);
    };

    return (
        <>
            <CA.CampaignAddContainer>
                <CA.LinkNavigate>
                    <CA.StyledLink
                        to={campaignListPath}
                        onClick={e => {
                            if (location.pathname === campaignListPath) e.preventDefault();
                        }}
                        current={location.pathname === campaignListPath}
                    >
                        캠페인
                    </CA.StyledLink>
                    {id && (
                        <CA.StyledLink
                            to={campaignEditPath}
                            onClick={e => {
                                if (location.pathname === campaignEditPath) e.preventDefault();
                            }}
                            current={location.pathname === campaignEditPath}
                        >
                            캠페인 수정
                        </CA.StyledLink>
                    )}
                    {!id && (
                        <CA.StyledLink
                            to={campaignAddPath}
                            onClick={e => {
                                if (location.pathname === campaignAddPath) e.preventDefault();
                            }}
                            current={location.pathname === campaignAddPath}
                        >
                            캠페인 등록
                        </CA.StyledLink>
                    )}
                </CA.LinkNavigate>

                <Form
                    form={form}
                    initialValues={newData}
                    onFinish={handleSubmit}
                    onValuesChange={handleFormValuesChange}
                    onFinishFailed={handleFinishFailed}
                    layout="vertical"
                    style={{ width: '100%' }}
                >
                    <CA.ModalWrapper>
                        {/* 캠페인 제목과 변경 이력 버튼 */}
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginBottom: '24px'
                        }}></div>
                        <CA.CampaignAddTitle>{id ? '캠페인 수정' : '캠페인 등록'}</CA.CampaignAddTitle>
                        {id && (
                            <Button
                                icon={<HistoryOutlined />}
                                onClick={() => {
                                    setChangeHistoryPage(1);
                                    fetchChangeHistory(parseInt(id), 1);
                                    setChangeHistoryVisible(true);
                                }}
                                style={{ marginLeft: 'auto' }}
                            >
                                변경 이력 보기
                            </Button>
                        )}
                        <CA.StyledFormItem
                            label="캠페인 제목"
                            name="title"
                            rules={[
                                { required: true, message: '캠페인 제목을 입력해 주세요.' },
                                { max: 50, message: '캠페인 제목은 최대 50자까지 입력 가능합니다.' }
                            ]}
                        >
                            <CA.InputField
                                maxLength={50}
                                name="title"
                                onChange={handleInputChange}
                                type="text"
                                placeholder="캠페인 제목을 입력해 주세요.(최대 50자)"
                            />
                        </CA.StyledFormItem>

                        {user?.role_name !== 'advertiser' && (
                            <CA.StyledFormItem
                                name="agency_id"
                                label="대행사"
                                rules={[
                                    { required: true, message: '대행사를 선택해주세요.' },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            const selectedAgency = agencies.find(ad => ad?.id?.toString() === value);
                                            if (selectedAgency && selectedAgency.status !== 'a') {
                                                return Promise.reject(new Error('선택한 대행사가 승인 상태가 아닙니다.'));
                                            }
                                            return Promise.resolve();
                                        },
                                    }),
                                ]}
                            >
                                <CA.SelectField
                                    showSearch
                                    placeholder="대행사 (검색 가능)"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                                    }
                                    onChange={handleSelectChange('agency_id')}
                                >
                                    {agencies.map(agency => (
                                        <Option key={agency.id?.toString()} value={agency.id?.toString()}>
                                            {agency.name}
                                        </Option>
                                    ))}
                                </CA.SelectField>
                            </CA.StyledFormItem>
                        )}

                        <CA.StyledFormItem
                            name="advertiser_id"
                            label="광고주"
                            rules={[
                                { required: true, message: '광고주를 선택해주세요.' },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        const selectedAdvertiser = clients.find(ad => ad?.id?.toString() === value);
                                        if (selectedAdvertiser && selectedAdvertiser.status !== 'a') {
                                            return Promise.reject(new Error('선택한 광고주가 승인 상태가 아닙니다.'));
                                        }
                                        return Promise.resolve();
                                    },
                                }),
                            ]}
                        >
                            <CA.SelectField
                                showSearch
                                placeholder="광고주 (검색 가능)"
                                optionFilterProp="children"
                                disabled={agencySelected != true}
                                filterOption={(input, option) =>
                                    (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                                }
                                onChange={handleSelectChange('advertiser_id')}
                            >
                                {clients.map(advertiser => (
                                    <Option key={advertiser.id?.toString()} value={advertiser.id?.toString()}>
                                        {advertiser.name}
                                    </Option>
                                ))}
                            </CA.SelectField>
                        </CA.StyledFormItem>

                        <CA.StyledFormItem
                            name="campaign_product_id"
                            label="상품"
                            rules={[
                                { required: true, message: '상품을 선택해주세요.' },
                            ]}
                        >
                            <CA.SelectField
                                showSearch
                                placeholder="상품 (검색 가능)"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
                                }
                                onChange={handleSelectChange('campaign_product_id')}
                            >
                                {campaignProducts.map(campaignProduct => (
                                    <Option key={campaignProduct.id?.toString()} value={campaignProduct.id?.toString()}>
                                        {campaignProduct.name}
                                    </Option>
                                ))}
                            </CA.SelectField>
                        </CA.StyledFormItem>

                        {/* 이벤트 이름 필드 - App 타입일 때만 필수 */}
                        {isAppType && (
                            <CA.StyledFormItem
                                label="이벤트 이름"
                                name="event_name"
                                rules={[
                                    { required: eventNameRequired, message: '이벤트 이름을 입력해 주세요.' }
                                ]}
                            >
                                <CA.InputField
                                    name="event_name"
                                    onChange={handleInputChange}
                                    type="text"
                                    placeholder="이벤트 이름을 입력해 주세요"
                                />
                            </CA.StyledFormItem>
                        )}

                        {isTotalImage ? (
                            <div>
                                <Upload
                                    beforeUpload={beforeUpload}
                                    showUploadList={false}
                                    maxCount={1}
                                >
                                    <Button icon={<UploadOutlined />}>
                                        텍스트 추출할 이미지를 업로드 해주세요
                                    </Button>
                                </Upload>

                                <CA.ExtractedTextWrapper>
                                    <CA.StyledFormItem label="추출된 텍스트">
                                        {extractedTexts.map((text, index) => (
                                            <Tag key={index} closable onClose={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                handleRemoveText(index);
                                            }}>
                                                {text}
                                            </Tag>
                                        ))}
                                    </CA.StyledFormItem>
                                </CA.ExtractedTextWrapper>
                            </div>
                        ) : []}

                        <CA.DatePickerBox>
                            <CA.StyledFormItem
                                name="start_date"
                                label="시작 날짜"
                                rules={[{ required: true, message: '시작 날짜를 선택해주세요.' }]}
                            >
                                <CA.StyledDatePicker
                                    name="start_date"
                                    onChange={handleStartDateChange}
                                    placeholder="시작 날짜 선택"
                                    disabledDate={disabledStartDate}
                                />
                            </CA.StyledFormItem>

                            <CA.StyledFormItem
                                name="end_date"
                                label={<>
                                    종료 날짜
                                    <Checkbox
                                        style={{ marginLeft: '10px' }}
                                        checked={isEndDateRequired}
                                        onChange={handleCheckboxChange}
                                    >
                                        활성화
                                    </Checkbox>
                                </>}
                                rules={[{ required: isEndDateRequired, message: '종료 날짜를 선택해주세요.' }]}
                            >
                                <CA.StyledDatePicker
                                    name="end_date"
                                    onChange={handleEndDateChange}
                                    placeholder="종료 날짜 선택"
                                    disabledDate={disabledEndDate}
                                    disabled={!isEndDateRequired}
                                />
                            </CA.StyledFormItem>
                        </CA.DatePickerBox>

                        <CA.StyledFormItem name="status" label="상태" rules={[{ required: true, message: '상태를 선택해주세요.' }]}>
                            <CA.SelectField onChange={handleSelectChange('status')} placeholder="상태 선택">
                                <Option value="a">승인</Option>
                                <Option value="p">대기</Option>
                                <Option value="d">반려</Option>
                            </CA.SelectField>
                        </CA.StyledFormItem>

                        <CA.twoPageModalWrapper>
                            <CA.StyledFormItem
                                label="관련 콘텐츠"
                                name="related_content"
                                rules={[{ required: relatedContentActive, message: '관련 콘텐츠를 입력해 주세요.' }]}
                            >
                                <CA.InputField
                                    name="related_content"
                                    onChange={handleInputChange}
                                    type="text"
                                    placeholder="ex) 유튜브 채널 이름, 인스타그램 아이디 이름 등"
                                    disabled={!relatedContentActive}
                                />
                            </CA.StyledFormItem>

                            <CA.StyledFormItem
                                label="참여 URL"
                                name="related_url"
                                rules={[
                                    { required: true, message: '참여 URL을 입력해 주세요.' },
                                    {
                                        pattern: /^(http:\/\/|https:\/\/).*/,
                                        message: 'URL은 http:// 또는 https://로 시작해야 합니다.',
                                    },
                                ]}
                            >
                                <CA.InputField
                                    name="related_url"
                                    onChange={handleInputChange}
                                    type="text"
                                    placeholder="예) https://www.example.com"
                                />
                            </CA.StyledFormItem>

                            <CA.StyledFormItem
                                label="총 집행 광고비 (vat별도)"
                                name="total_points"
                                rules={[
                                    { required: true, message: '캠페인 총 집행 광고비를 입력해 주세요.' },
                                    {
                                        validator: (_, value) => {
                                            const numericValue = getNumericValue(value || '');
                                            if (!numericValue) {
                                                return Promise.reject(new Error('숫자를 입력해 주세요.'));
                                            }
                                            return Promise.resolve();
                                        }
                                    },
                                ]}
                            >
                                <CA.InputField
                                    name="total_points"
                                    onChange={handleInputChange}
                                    type="text"
                                    placeholder="총 집행 광고비 (vat별도)"
                                    suffix="원"
                                />
                            </CA.StyledFormItem>

                            {/* 단가 섹션 - 생성 시에만 표시, 수정 시에는 현재 단가와 관리 버튼 표시 */}
                            {!id ? (
                                // 캠페인 생성 시 - 단가 입력 필드
                                <>
                                    <CA.StyledFormItem
                                        label="광고 단가 (vat별도)"
                                        name="points_per_call"
                                        rules={[
                                            { required: true, message: '광고 단가를 입력해 주세요.' },
                                            {
                                                validator: (_, value) => {

                                                    // required에서 이미 빈 값을 체크하므로, 여기서는 값이 있을 때만 검증
                                                    if (!value && value !== 0 && value !== '0') {
                                                        return Promise.resolve(); // required에서 처리하므로 여기서는 통과
                                                    }

                                                    const numericValue = typeof value === 'string' ? getNumericValue(value) : value.toString();
                                                    const parsedValue = parseInt(numericValue);
                                                    if (isNaN(parsedValue) || parsedValue < 0) {
                                                        return Promise.reject(new Error('0 이상의 숫자를 입력해 주세요.'));
                                                    }

                                                    const totalPoints = getNumericValue(form.getFieldValue('total_points') || '');

                                                    if (totalPoints && parsedValue > parseInt(totalPoints)) {
                                                        return Promise.reject(new Error('광고 단가는 총 집행 광고비보다 작거나 같아야 합니다.'));
                                                    }

                                                    return Promise.resolve();
                                                }
                                            },
                                        ]}
                                    >
                                        <CA.InputField
                                            name="points_per_call"
                                            onChange={handleInputChange}
                                            type="text"
                                            placeholder="광고 단가 (vat별도)"
                                            suffix="원"
                                            readOnly={user?.role_name === 'advertiser'}
                                            disabled={user?.role_name === 'advertiser'}
                                        />
                                    </CA.StyledFormItem>

                                    <CA.StyledFormItem
                                        label="고객 리워드 (vat별도)"
                                        name="points_per_participant"
                                        rules={[
                                            { required: true, message: '고객 리워드를 입력해 주세요.' },
                                            {
                                                validator: (_, value) => {
                                                    // required에서 이미 빈 값을 체크하므로, 여기서는 값이 있을 때만 검증
                                                    if (!value && value !== 0 && value !== '0') {
                                                        return Promise.resolve();
                                                    }

                                                    const numericValue = typeof value === 'string' ? getNumericValue(value) : value.toString();
                                                    const parsedValue = parseInt(numericValue);
                                                    if (isNaN(parsedValue) || parsedValue < 0) {
                                                        return Promise.reject(new Error('0 이상의 숫자를 입력해 주세요.'));
                                                    }

                                                    return Promise.resolve();
                                                }
                                            },
                                        ]}
                                    >
                                        <CA.InputField
                                            name="points_per_participant"
                                            onChange={handleInputChange}
                                            type="text"
                                            placeholder="고객 리워드 (vat별도)"
                                            suffix="원"
                                            readOnly={user?.role_name === 'advertiser'}
                                            disabled={user?.role_name === 'advertiser'}
                                        />
                                    </CA.StyledFormItem>
                                </>
                            ) : (
                                // 캠페인 수정 시 - 현재 단가 표시와 관리 버튼
                                <div style={{ position: 'relative' }}>
                                    <div style={{
                                        display: 'flex',
                                        gap: '16px',
                                        alignItems: 'flex-end',
                                        marginBottom: '16px'
                                    }}>
                                        <div style={{ flex: 1 }}>
                                            <label style={{
                                                display: 'block',
                                                marginBottom: '8px',
                                                fontWeight: 'bold'
                                            }}>
                                                현재 적용 단가
                                            </label>
                                            <div style={{
                                                display: 'flex',
                                                gap: '12px',
                                                alignItems: 'center',
                                                padding: '12px',
                                                backgroundColor: '#f5f5f5',
                                                borderRadius: '6px',
                                                border: '1px solid #d9d9d9'
                                            }}>
                                                <div>
                                                    <span style={{ color: '#666', fontSize: '12px' }}>광고 단가: </span>
                                                    <span style={{ fontWeight: 'bold' }}>
                                                        {currentPricing.points_per_call.toLocaleString()}원
                                                    </span>
                                                </div>
                                                <div style={{ width: '1px', height: '20px', backgroundColor: '#d9d9d9' }} />
                                                <div>
                                                    <span style={{ color: '#666', fontSize: '12px' }}>고객 리워드: </span>
                                                    <span style={{ fontWeight: 'bold' }}>
                                                        {currentPricing.points_per_participant.toLocaleString()}원
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{
                                            display: 'flex',
                                            gap: '8px',
                                            position: 'absolute',
                                            right: 0,
                                            top: 0
                                        }}>
                                            <Button
                                                type="primary"
                                                icon={<EditOutlined />}
                                                size="small"
                                                onClick={() => {
                                                    setEditingPricing(null);
                                                    pricingForm.resetFields();
                                                    setPricingChangeVisible(true);
                                                }}
                                            >
                                                단가 변경하기
                                            </Button>
                                            <Button
                                                icon={<HistoryOutlined />}
                                                size="small"
                                                onClick={() => setPricingHistoryVisible(true)}
                                            >
                                                이력 보기
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {/* 일일 적립 수 제한 설정 - 생성과 수정 모두에서 표시 */}
                            <CA.StyledFormItem
                                name="daily_cap_checkbox"
                                label="일일 적립 수 제한"
                            >
                                <Checkbox
                                    checked={isDailyCapEnabled}
                                    onChange={handleDailyCapToggle}
                                >
                                    일일 적립 수 제한 설정
                                </Checkbox>
                            </CA.StyledFormItem>

                            {isDailyCapEnabled && (
                                <CA.StyledFormItem
                                    label="일일 최대 적립 수"
                                    name="daily_cap"
                                    rules={[
                                        { required: true, message: '일일 적립 수를 입력해주세요.' },
                                        { pattern: /^[0-9]+$/, message: '숫자만 입력해주세요.' },
                                        {
                                            validator: (_, value) => {
                                                const num = parseInt(value);
                                                if (num <= 0) {
                                                    return Promise.reject(new Error('1 이상의 숫자를 입력해주세요.'));
                                                }
                                                if (num > 10000) {
                                                    return Promise.reject(new Error('10000 이하의 숫자를 입력해주세요.'));
                                                }
                                                return Promise.resolve();
                                            }
                                        }
                                    ]}
                                >
                                    <CA.InputField
                                        name="daily_cap"
                                        onChange={handleInputChange}
                                        type="text"
                                        placeholder="일일 최대 적립 가능 수"
                                        suffix="회"
                                    />
                                </CA.StyledFormItem>
                            )}

                            {/* 캠페인 수정 시에만 테스트 기간 설정 UI 표시 */}
                            {id && (
                                <>
                                    <CA.StyledFormItem
                                        name="test_period_checkbox"
                                        label="테스트 기간 설정"
                                    >
                                        <Checkbox
                                            checked={isTestPeriodEnabled}
                                            onChange={handleTestPeriodToggle}
                                        >
                                            테스트 기간 설정
                                        </Checkbox>
                                    </CA.StyledFormItem>

                                    {isTestPeriodEnabled && (
                                        <CA.DatePickerBox>
                                            <CA.StyledFormItem
                                                name="test_start_date"
                                                label="테스트 시작일"
                                                rules={[
                                                    { required: true, message: '테스트 시작일을 선택해주세요.' },
                                                    {
                                                        validator: (_, value) => {
                                                            if (!value) return Promise.resolve();

                                                            if (startDate && value.isAfter(startDate.subtract(1, 'day'))) {
                                                                return Promise.reject(new Error('테스트 시작일은 캠페인 시작일 이전이어야 합니다.'));
                                                            }

                                                            return Promise.resolve();
                                                        }
                                                    }
                                                ]}
                                            >
                                                <CA.StyledDatePicker
                                                    name="test_start_date"
                                                    onChange={handleTestStartDateChange}
                                                    placeholder="테스트 시작일 선택"
                                                    disabledDate={disabledTestStartDate}
                                                />
                                            </CA.StyledFormItem>

                                            <CA.StyledFormItem
                                                name="test_end_date"
                                                label="테스트 종료일"
                                                rules={[
                                                    { required: true, message: '테스트 종료일을 선택해주세요.' },
                                                    {
                                                        validator: (_, value) => {
                                                            if (!value) return Promise.resolve();

                                                            if (testStartDate && value.isBefore(testStartDate.startOf('day'))) {
                                                                return Promise.reject(new Error('테스트 종료일은 테스트 시작일 이후여야 합니다.'));
                                                            }

                                                            if (startDate && value.isAfter(startDate.subtract(1, 'day'))) {
                                                                return Promise.reject(new Error('테스트 종료일은 캠페인 시작일 이전이어야 합니다.'));
                                                            }

                                                            return Promise.resolve();
                                                        }
                                                    }
                                                ]}
                                            >
                                                <CA.StyledDatePicker
                                                    name="test_end_date"
                                                    onChange={handleTestEndDateChange}
                                                    placeholder="테스트 종료일 선택"
                                                    disabledDate={disabledTestEndDate}
                                                />
                                            </CA.StyledFormItem>
                                        </CA.DatePickerBox>
                                    )}
                                </>
                            )}
                        </CA.twoPageModalWrapper>

                        {/* 서브 캠페인 컴포넌트 */}
                        <SubCampaignComponent
                            form={form}
                            initialSubCampaigns={subCampaigns}
                            isAppType={isAppType}
                            onChange={handleSubCampaignsChange}
                        />
                    </CA.ModalWrapper>

                    <CA.ThreePageModalWrapper>
                        {isTotalImage ? (
                            <div>
                                <CA.MobileAddTitle>통합 이미지 분석 예시</CA.MobileAddTitle>
                                <CA.SmallBannerDisplay>
                                    <CA.ListBannerImage name="total_img_ex_img">
                                        <ImageUpload
                                            onImageUpload={handleTotalExImageUpload}
                                            initialImageUrls={totalImageExImages}
                                            bannerType="total_img_ex_img"
                                        />
                                    </CA.ListBannerImage>
                                </CA.SmallBannerDisplay>
                            </div>
                        ) : []}

                        <CA.MobileAddTitle>리스트 배너</CA.MobileAddTitle>
                        <CA.SmallBannerDisplay>
                            <CA.ListBannerImage name="small_banner_img">
                                <ImageUpload
                                    onImageUpload={handleSubImageUpload}
                                    initialImageUrls={subBannerImages}
                                    bannerType="small_banner_img"
                                />
                            </CA.ListBannerImage>
                            <CA.ListCampaignContainer>
                                <CA.ListCampaignBox>
                                    <CA.ListBannerImageBox>
                                        {subBannerImages.length > 0 ? (
                                            subBannerImages.map((imageUrl, index) => (
                                                <img
                                                    key={index}
                                                    src={imageUrl}
                                                    alt={`Small Banner Preview ${index}`}
                                                    style={{ width: '100%', height: '210px' }}
                                                />
                                            ))
                                        ) : (
                                            <img
                                                src={SmallBannerDefalutImage}
                                                alt="Default Banner Preview"
                                                style={{ width: '100%', height: '210px' }}
                                            />
                                        )}
                                    </CA.ListBannerImageBox>
                                    <CA.ListCampaignInfo>
                                        <CA.ListCampaignInfoText>
                                            <CA.ListCampaignTitle>{newData.title}</CA.ListCampaignTitle>
                                            {newData.media && newData.authentication_method && (
                                                <CA.ListCampaignInfoText>
                                                    {selectedMedia?.k_name}{' '}
                                                    {selectedMedia?.auth.find(auth => auth[0] === newData.authentication_method)?.[1]}{' '}
                                                    네이버페이 받기
                                                </CA.ListCampaignInfoText>
                                            )}
                                        </CA.ListCampaignInfoText>
                                        <CA.ListCampaignInfoBtn>{100} P</CA.ListCampaignInfoBtn>
                                    </CA.ListCampaignInfo>
                                </CA.ListCampaignBox>
                            </CA.ListCampaignContainer>
                        </CA.SmallBannerDisplay>

                        <CA.MobileAddTitle>모바일 화면 구성</CA.MobileAddTitle>
                        <CA.MobileAddContainer>
                            <div>
                                <CA.MobileImgInfo>모바일 화면을 구성할 값을 입력해주세요.</CA.MobileImgInfo>
                                <CA.MobileWrapper>
                                    <CA.MobileImgBox name="banner_img">
                                        <ImageUpload
                                            onImageUpload={handleImageUpload}
                                            initialImageUrls={bannerImages}
                                            bannerType="banner_img"
                                        />
                                    </CA.MobileImgBox>
                                    <CA.StyledFormItem
                                        name="campaign_content"
                                        rules={[{ required: true, message: '광고 문구를 입력해 주세요.' }]}
                                        label="광고 문구"
                                    >
                                        <CA.ContentInputField
                                            autoSize={{ minRows: 1 }}
                                            name="campaign_content"
                                            onChange={handleInputChange}
                                            placeholder="광고 문구 입력"
                                        />
                                    </CA.StyledFormItem>
                                    <CA.StyledFormItem
                                        name="campaign_details"
                                        rules={[{ required: true, message: '상세 내용을 입력해 주세요.' }]}
                                        label="상세 설명"
                                    >
                                        <CA.MobileContent
                                            autoSize={{ minRows: 6 }}
                                            name="campaign_details"
                                            onChange={handleInputChange}
                                            placeholder="상세 내용을 입력해 주세요."
                                        />
                                    </CA.StyledFormItem>
                                </CA.MobileWrapper>
                            </div>
                            <div>
                                <CA.MobileRightInfo>모바일 화면 미리보기</CA.MobileRightInfo>
                                <CA.RightPreviewBox>
                                    <CA.MobilePreviewImgBox>
                                        {bannerImages.length > 0 ? (
                                            bannerImages.map((imageUrl, index) => (
                                                <img
                                                    key={index}
                                                    src={imageUrl}
                                                    alt={`Banner Preview ${index}`}
                                                    style={{ width: '100%', height: 'auto' }}
                                                />
                                            ))
                                        ) : (
                                            <img
                                                src={CampaignDefaultImage}
                                                alt="Default Banner Preview"
                                                style={{ width: '100%', height: 'auto' }}
                                            />
                                        )}
                                    </CA.MobilePreviewImgBox>
                                    <CA.MobileContentPreview>
                                        <CA.MobileTitlePreview>{campaignContent || '광고 문구가 입력됩니다'}</CA.MobileTitlePreview>
                                        <CA.MobileContentPreviewDetail>
                                            {campaignDetails || '상세 설명이 입력됩니다.'}
                                        </CA.MobileContentPreviewDetail>
                                        <CA.MobilePointButton>참여하고 즉시 포인트 받기</CA.MobilePointButton>
                                    </CA.MobileContentPreview>
                                    <CA.AdditionaTextBox>
                                        <CA.AdditionaTextItem>
                                            <CA.Star>*</CA.Star> 최초 1회만 참여 가능합니다.
                                        </CA.AdditionaTextItem>
                                        <CA.AdditionaTextItem>
                                            <CA.Star>*</CA.Star> 이벤트 참여 전 개인정보 동의가 필요합니다.
                                        </CA.AdditionaTextItem>
                                        <CA.AdditionaTextItem>
                                            <CA.Star>*</CA.Star> 네이버페이 포인트 적립 시 회원가입이 필요합니다.
                                        </CA.AdditionaTextItem>
                                        <CA.AdditionaTextItem>
                                            <CA.Star>*</CA.Star> 이미 구독중일 경우 리워드는 지급되지 않습니다.
                                        </CA.AdditionaTextItem>
                                        <CA.AdditionaTextItem>
                                            <CA.Star>*</CA.Star> 다크모드로 스크린샷을 찍을 경우 인식이 어려울 수 있습니다.
                                        </CA.AdditionaTextItem>
                                        <CA.AdditionaTextItem>
                                            <CA.ContactUsBtn>
                                                <p>지급 문의</p> <span>는 여기를 눌러주세요 {'>'}</span>
                                            </CA.ContactUsBtn>
                                        </CA.AdditionaTextItem>
                                    </CA.AdditionaTextBox>
                                </CA.RightPreviewBox>
                            </div>
                        </CA.MobileAddContainer>
                    </CA.ThreePageModalWrapper>

                    <CA.SubmitButton type="primary" htmlType="submit">
                        {id ? '캠페인 수정하기' : '캠페인 등록하기'}
                    </CA.SubmitButton>
                </Form>

                {/* 변경 이력 조회 모달 */}
                <Modal
                    title={
                        <div>
                            <HistoryOutlined style={{ marginRight: 8 }} />
                            캠페인 변경 이력
                        </div>
                    }
                    open={changeHistoryVisible}
                    onCancel={() => setChangeHistoryVisible(false)}
                    footer={[
                        <Button key="close" onClick={() => setChangeHistoryVisible(false)}>
                            닫기
                        </Button>
                    ]}
                    width={1000}
                    style={{ top: 20 }}
                >
                    <Table
                        dataSource={changeHistory}
                        columns={changeHistoryColumns}
                        rowKey="id"
                        loading={changeHistoryLoading}
                        pagination={{
                            current: changeHistoryPage,
                            total: changeHistoryTotal,
                            pageSize: 10,
                            showSizeChanger: false,
                            showQuickJumper: true,
                            showTotal: (total, range) =>
                                `${range[0]}-${range[1]} / 총 ${total}개`,
                            onChange: (page) => {
                                setChangeHistoryPage(page);
                                if (id) {
                                    fetchChangeHistory(parseInt(id), page);
                                }
                            }
                        }}
                        size="small"
                        scroll={{ y: 400 }}
                    />
                </Modal>

                {/* 단가 변경 모달 */}
                <Modal
                    title={editingPricing ? '단가 수정' : '단가 변경'}
                    open={pricingChangeVisible}
                    onCancel={() => {
                        setPricingChangeVisible(false);
                        setEditingPricing(null);
                        pricingForm.resetFields();
                    }}
                    footer={null}
                    width={600}
                >
                    <Form
                        form={pricingForm}
                        layout="vertical"
                        onFinish={handlePricingSubmit}
                    >
                        <Form.Item
                            name="effective_datetime"
                            label="적용 일시"
                            rules={[{ required: true, message: '적용 일시를 선택해주세요.' }]}
                        >
                            <DatePicker
                                showTime
                                format="YYYY-MM-DD HH:mm"
                                placeholder="적용 일시 선택"
                                style={{ width: '100%' }}
                                disabledDate={(current) => current && current < dayjs().startOf('day')}
                            />
                        </Form.Item>

                        <div style={{ display: 'flex', gap: '16px' }}>
                            <Form.Item
                                name="points_per_call"
                                label="광고 단가"
                                rules={[
                                    { required: true, message: '광고 단가를 입력해주세요.' },
                                    {
                                        validator: (_, value) => {
                                            // required에서 이미 빈 값을 체크하므로, 여기서는 값이 있을 때만 검증
                                            if (!value && value !== 0 && value !== '0') {
                                                return Promise.resolve();
                                            }

                                            const numericValue = typeof value === 'string' ? getNumericValue(value) : value.toString();
                                            const parsedValue = parseInt(numericValue);
                                            if (isNaN(parsedValue) || parsedValue < 0) {
                                                return Promise.reject(new Error('0 이상의 숫자를 입력해 주세요.'));
                                            }

                                            return Promise.resolve();
                                        }
                                    },
                                ]}
                                style={{ flex: 1 }}
                            >
                                <Input
                                    placeholder="광고 단가 입력"
                                    suffix="원"
                                    onChange={handlePricingInputChange('points_per_call')}
                                />
                            </Form.Item>

                            <Form.Item
                                name="points_per_participant"
                                label="고객 리워드"
                                rules={[
                                    { required: true, message: '고객 리워드를 입력해주세요.' },
                                    {
                                        validator: (_, value) => {
                                            // required에서 이미 빈 값을 체크하므로, 여기서는 값이 있을 때만 검증
                                            if (!value && value !== 0 && value !== '0') {
                                                return Promise.resolve();
                                            }

                                            const numericValue = typeof value === 'string' ? getNumericValue(value) : value.toString();
                                            const parsedValue = parseInt(numericValue);
                                            if (isNaN(parsedValue) || parsedValue < 0) {
                                                return Promise.reject(new Error('0 이상의 숫자를 입력해 주세요.'));
                                            }

                                            return Promise.resolve();
                                        }
                                    },
                                ]}
                                style={{ flex: 1 }}
                            >
                                <Input
                                    placeholder="고객 리워드 입력"
                                    suffix="원"
                                    onChange={handlePricingInputChange('points_per_participant')}
                                />
                            </Form.Item>
                        </div>

                        <div style={{ textAlign: 'right', marginTop: '24px' }}>
                            <Button
                                onClick={() => {
                                    setPricingChangeVisible(false);
                                    setEditingPricing(null);
                                    pricingForm.resetFields();
                                }}
                                style={{ marginRight: '8px' }}
                            >
                                취소
                            </Button>
                            <Button type="primary" htmlType="submit">
                                {editingPricing ? '수정' : '저장'}
                            </Button>
                        </div>
                    </Form>
                </Modal>

                {/* 단가 이력 조회 모달 */}
                <Modal
                    title="단가 변경 이력"
                    open={pricingHistoryVisible}
                    onCancel={() => setPricingHistoryVisible(false)}
                    footer={[
                        <Button key="close" onClick={() => setPricingHistoryVisible(false)}>
                            닫기
                        </Button>
                    ]}
                    width={800}
                >
                    <Table
                        dataSource={pricingHistory}
                        columns={pricingHistoryColumns}
                        rowKey="id"
                        pagination={false}
                        size="small"
                    />
                </Modal>
            </CA.CampaignAddContainer>
        </>
    );
}

export default CampaignAdd;